<template>
    <header id="hd">
        <h1><a :href="aUrl"><img src="../../../static/img/logo.png"></a></h1>
        <nav>
            <a v-for="item in navList" :key="item.name" :href="'' + item.link">{{item.name}}</a>
        </nav>
        <menu>
            <span></span>
        </menu>
        <div class="list-menu" v-if="menuList">
            <div class="menu-content">
                <dl v-for="item in menuList" :key="item.name" :class="item.children ? 'children' : ''">
                    <dt v-if="item.link!='/order/list'"><a :href="!item.children ? '' + item.link : 'javascript:;'">{{item.name}}</a></dt>
                    <dt v-else><a :href="!item.children ? item.link : 'javascript:;'" >{{item.name}}</a></dt>
                    <!-- <dt v-else><a :href="!item.children ? item.link : 'javascript:;'" class="active">{{item.name}}</a></dt> -->
                    <dd v-if="item.children">
                        <a v-for="items in item.children" :key="items.name" :href="'' + items.link">{{items.name}}</a>
                    </dd>
                </dl>
                <div v-if="userInfo.userName" class="last">
                    <a style="background:none;">{{userInfo.userDisplayName}}</a>
                    <a @click="logOut">退出</a>
                </div>
                <div v-else class="last">
                    <a :href="aUrl + '/login'">登录</a>
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import api from "@/h5Api/defaultApi";
import Cookies from 'js-cookie'

export default {
    name: 'order-list',
    components: {
    },
    data() {
        return {
            aUrl: '/m',
            activeNames: [],
            ts: new Date().getTime(),
            navList:[
                {
                   name: '拖车运价',
                   link: '/m/query_charge_new'
                },
                {
                   name: '订单中心',
                   link: '/order/list'
                }
            ],
            menuList: [
                {
                   name: '首页',
                   link: '/m'
                },
                {
                   name: '订单中心',
                   link: '/order/list'
                },
                {
                   name: '服务产品',
                   link: '/serverProduct',
                  //  children: [
                  //      {
                  //          name: '公司新闻',
                  //          link: '/article/category/H_R_0',
                  //      },
                  //      {
                  //          name: '行业动态',
                  //          link: '/article/category/H_R_1',
                  //      }
                  //  ]
                },
                {
                   name: '关于我们',
                   link: '/aboutUs',
                  //  children: [
                  //      {
                  //          name: '运力介绍',
                  //          link: '/article/category/H_B_0',
                  //      },
                  //      {
                  //          name: '专业队伍',
                  //          link: '/article/category/H_B_1',
                  //      },
                  //      {
                  //          name: '资质荣誉',
                  //          link: '/article/category/H_B_2',
                  //      },
                  //      {
                  //          name: '合作伙伴',
                  //          link: '/article/category/H_B_3',
                  //      },
                  //      {
                  //          name: '服务承诺',
                  //          link: '/article/category/H_B_4',
                  //      }
                  //  ]
                }
            ]
        };
    },
    computed: {
        userInfo(){
            return this.$store.state.selectShop.user
        }
    },
    methods: {
        user(){

            api.user('0=' + this.ts).then(res=>{
                if(res.data.success){
                    this.$store.dispatch('mUser',res.data.user)
                }else{
                    console.log(this.$route);
                    if (this.$route.name != 'copyMsg' && this.$route.name != 'aboutUs' && this.$route.name != 'serverProduct') {
                        window.location.href = this.aUrl + '/login'
                    }
                }
            })
        },
        logOut(){
            api.logout('').then(res=>{
                localStorage.removeItem('info')
                window.location.href = this.aUrl + '/login?logout=true'
            })
        }
    },
    created(){
        this.user()
    },
    mounted(){
        console.log(1)

        $('#hd').on('click','menu',function(){
            $('html').toggleClass('on')
            $(this).toggleClass('active')
		    $(this).next('.list-menu').stop().slideToggle()
        })
        $('#hd').on('click','.list-menu',function(){
            $('html').removeClass('on')
            $('#hd menu').removeClass('active')
            $('.list-menu').slideUp()
        })
        $('#hd').on('click','.menu-content',function(e){
            e.stopPropagation()
        })
        $('#hd').on('click','dl.children',function(){
            $(this).toggleClass('on')
            $(this).find('dd').stop().slideToggle()
        })
    },
    watch:{
        $route (to, from) {
            localStorage.setItem('path',window.location.href)
        }
    }
}
</script>
<style lang="scss" scoped>
#hd{
    position:fixed;
    z-index:999;
    left:0;
    right:0;
    top:0;
    height:.96rem;
    padding:0 .2rem;
    display:flex;
    justify-content:space-between;
    align-items:center;
    background: #02cad6;
    h1{
        width:1.56rem;
        a{
            display:block;
        }
    }
    a{
        color:#fff;
    }
    nav{
        display:flex;
        line-height:.96rem;
        a{
            position:relative;
            padding:0 .5em;
            &:before{
                content:'';
                position:absolute;
                top:50%;
                left:0;
                transform:translateY(-50%);
                height:1em;
                border-left:1px solid;
            }
            &:first-child:before{
                border-left:none;
            }
        }
    }
    menu{
        position:relative;
        width:.3rem;
        height:100%;
        padding:0 .5em;
        span{
            position:absolute;
            left:.5em;
            width:.3rem;
            top:50%;
            transform:translateY(-50%);
            height:.04rem;
            background: #Fff;
            &:before,
            &:after{
                content:'';
                position:absolute;
                top:0;
                right:0;
                bottom:0;
                left:0;
                background:#Fff;
                transition:.3s;
            }
            &:before{transform:translateY(-250%);}
            &:after{transform:translateY(250%);}
        }
        &.active{
            span{
                background:transparent;
                &:before{transform:translateY(0) rotate(45deg);}
                &:after{transform:translateY(0) rotate(-45deg);}
            }
        }
    }
    .list-menu{
        position:absolute;
        top:.96rem;
        right:0;
        left:0;
        height:calc(100vh - .96rem);
        line-height:.6rem;
        display:none;
        background:transparent;
        .active{
            color:#02cad6;
        }
        .menu-content{
            max-height:100%;
            overflow:auto;
            background:rgba(28,48,56,.9);
            dl{
                border-bottom:rgba(255,255,255,.1) 1px solid;
            }
            .children{
                padding-bottom:.5em;
            }
            .children dt a{
                background-image:url(/static/img/zhankai@2x.png);
                background-size:.26rem .12rem;
                background-position:right 2em center;
            }
            .children.on dt a{
                background-image:url(/static/img/shouqi@2x.png);
            }
            dl a{
                display:block;
                padding:.5em 2em;
            }
            dd{
                display:none;
                a{
                    padding:0 3em;
                }
            }
            .last{
                line-height: .5rem;
                padding: .1rem .2rem .1rem 0;
                text-align: right;
                font-size: .24rem;
                a{
                    display: inline-block;
                    vertical-align: top;
                    min-width: 6em;
                    box-sizing: border-box;
                    padding: 0 1em;
                    background: #02cad6;
                    border-radius: .25rem;
                    text-align: center;
                    color: #fff;
                    text-align:center;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/grantAct/header.vue